import { Handler } from "pagedjs";
import createIndex from "@/views/readonly/studbook/util/createIndex";

class CustomHandler extends Handler {
    afterPreview() {
        // this console log is very importwant, do not remove it
        console.log("finishedLoading");
    }
}

export default CustomHandler;
